import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import {
  Stadium,
  StadiumDetail,
  StadiumMatch,
  StadiumMatchesQuery,
  UpdateStadiumMatchQualifierPayload,
} from '@features/stadiums/stadiums.models'
import { Listable } from '@core/models/listable.models'
import { Observable } from 'rxjs'
import { environment } from '@env'
import { Queryable } from '@core/models/queriable.models'

@Injectable({ providedIn: 'root' })
export class StadiumsApi {
  readonly #http: HttpClient = inject(HttpClient)

  fetchStadiums(query: Queryable): Observable<{ entities: Stadium[] } & Listable> {
    return this.#http.post<{ entities: Stadium[] } & Listable>(
      environment.API.SEARCH_STADIUMS,
      query,
    )
  }

  fetchStadium(stadiumId: string): Observable<StadiumDetail> {
    return this.#http.get<StadiumDetail>(`${environment.API.CRUD_STADIUM}/${stadiumId}`)
  }

  fetchStadiumMatches(
    matches: StadiumMatchesQuery,
  ): Observable<{ matches: StadiumMatch[] } & Listable> {
    return this.#http.post<{ matches: StadiumMatch[] } & Listable>(
      `${environment.API.SEARCH_STADIUM_MATCHES}`,
      matches,
    )
  }

  updateStadiumMatchQualifier(payload: UpdateStadiumMatchQualifierPayload) {
    return this.#http.put(environment.API.MATCH_QUALIFIERS, payload)
  }

  updateStadium(payload: StadiumDetail) {
    return this.#http.put(`${environment.API.CRUD_STADIUM}/${payload.id}`, payload)
  }
}
